// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"220":"72162bdd","305":"0d75d4d6","493":"fad37e0c","511":"68f13db9","630":"16adca7d","651":"393d8c65","666":"ce3838c7","765":"bbda3f83","846":"d3f70db6","867":"b1d2f0a0","926":"57d2ff76"}[chunkId] + ".chunk.js";
};